import { render, staticRenderFns } from "./FormDetailInvestigation.vue?vue&type=template&id=6c96d82d"
import script from "./FormDetailInvestigation.vue?vue&type=script&lang=js"
export * from "./FormDetailInvestigation.vue?vue&type=script&lang=js"
import style0 from "./FormDetailInvestigation.vue?vue&type=style&index=0&id=6c96d82d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports